import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Add.module.css'
import Plus from "../../../../assets/Icon/Plus";

const AddMarineModal = ({ marineService, defaultMarine }) => {
    const marineResetData = {
        name: "",
        mobile: "",
        address: "",
        address2: "",
        code: "",
        country: "",
        district: "",
        city: "",
        logo: "",
    }

    const [newMarine, setNewMarine] = useState(marineResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const validateMarine = (marine) => {
        const messages = {};
    
        if (marine.name.length < 2) {
            messages.name = { message: 'მიუთითეთ სათაური', isValid: false };
        }

    
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;  
      };

    const reValidate = () => {
        const isValidate = validateMarine(newMarine)
        
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateMarine(newMarine)
        }
      }, [newMarine, isFirstValidated]);

    const [isModalOpen, setIsModalOpen] = useState(false);
 
    const saveHandle = () => {
         
        const isValidate = validateMarine(newMarine)

        if (isValidate === true) {
            marineService.add(newMarine)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true) 
        } 
        
    };

    const handleMarineChange = async (event) => {
        let val = event.target.value;
        setNewMarine(prevMarine => ({
            ...prevMarine,
            [event.target.name]: val
        })); 
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true) 
        setIsFirstValidated(false)
        setNewMarine(marineResetData)
    }

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }
 
  
    const handleMarineInt = async (event) => {
        let val = event.target.value;
        
        setNewMarine(prevMarine => ({
            ...prevMarine,
            [event.target.name]: convertToInt(val)
        })); 
    };
  

    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; // Regular expression to match only numeric characters

        if (!regex.test(keyValue)) {
            event.preventDefault();
        }
    };
  
    return (
        <div>

            <span onClick={() => openAdd()} className={cl.AddBtn}>
                <span className={cl.icon} > <Plus /></span>
                დამატება
            </span>
  
            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.iconHead} > <Plus /></span> დამატება
                    </h3>
                </div>

                <div className={cl.groupInput}> 
                    <label>დასახელება</label>
                    <input type="textS" className={validates && validates.name ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="name" 
                        value={newMarine.name} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>
 

                <div className={cl.groupInput}> 
                    <label>მობილური</label>
                    <input type="textS" className={validates && validates.mobile ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="mobile" 
                        value={newMarine.mobile} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>მისამართი</label>
                    <input type="textS" className={validates && validates.address ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="address" 
                        value={newMarine.address} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>მისამართი 2</label>
                    <input type="textS" className={validates && validates.address2 ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="address2" 
                        value={newMarine.address2} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>ქვეყანა</label>
                    <input type="textS" className={validates && validates.country ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="country" 
                        value={newMarine.country} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>
  
                <div className={cl.groupInput}> 
                    <label>რეგიონი</label>
                    <input type="textS" className={validates && validates.district ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="district" 
                        value={newMarine.district} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>
  
                <div className={cl.groupInput}> 
                    <label>ქალაქი</label>
                    <input type="textS" className={validates && validates.city ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="city" 
                        value={newMarine.city} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>


                <div className={cl.groupInput}> 
                    <label>Logo</label>
                    <input type="textS" className={validates && validates.logo ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="logo" 
                        value={newMarine.logo} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>
 

                 
                  
                <span onClick={saveHandle} className={cl.btnPrimary}>დამატება</span>

            </Modal>
        </div>
    );
};

export default AddMarineModal;